<template>
    <ul class="social-links list-inline">
        <li v-for="(social, index) in socials" class="list-inline-item" :key="index">
            <a :href="social.href" target="_blank" rel="nofollow">
                <font-awesome-icon :icon="social.icon" prefix="fab"/>
            </a>
        </li>
    </ul>
</template>

<script>
    import { defineComponent } from 'vue';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    require('../font-awesome');

    export default defineComponent({
        name: 'SocialIcons',
        components: {
            FontAwesomeIcon,
        },
        data() {
            return {
                socials: [
                    {
                        href: 'https://www.facebook.com/Dominartinvest/',
                        icon: ['fab', 'facebook-f'],
                    },
                    {
                        href: 'https://www.instagram.com/dominartinvest/',
                        icon: ['fab', 'instagram'],
                    },
                    {
                        href: 'https://www.youtube.com/channel/UCTRtDTNIqP3CntyUidTq25w?view_as=subscriber',
                        icon: ['fab', 'youtube'],
                    },
                    {
                        href: 'https://t.me/dominartinvest',
                        icon: ['fab', 'telegram-plane'],
                    },
                    {
                        href: 'https://twitter.com/dominartinvest',
                        icon: ['fab', 'x-twitter'],
                    },
                    {
                        href: 'https://www.linkedin.com/in/sergeyvakhnenko/',
                        icon: ['fab', 'linkedin'],
                    },
                ],
            };
        },
    });
</script>

<style lang="scss">
    @import "~bootstrap/scss/vendor/rfs";
    @import "../../scss/variables";

    .social-links {
        a {
            @include font-size(70px);
            color: $light-blue-color;
            &:hover {
                color: $warning-color;
            }
        }
    }
</style>
